import { IconProps } from './types';

export { PlayCircleOutline as PlayVideoPreviewIcon } from '@mui/icons-material';

export const VideoIcon = (props: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 51.285 41.96'>
    <path
      // eslint-disable-next-line max-len
      d='M48.122,4.5H6.162A4.646,4.646,0,0,0,1.5,9.162V37.136A4.661,4.661,0,0,0,6.162,41.8H17.818V46.46H36.467V41.8H48.122a4.656,4.656,0,0,0,4.639-4.662l.023-27.973A4.661,4.661,0,0,0,48.122,4.5Zm0,32.636H6.162V9.162h41.96ZM36.467,23.149,20.149,32.473V13.824Z'
      transform='translate(-1.5 -4.5)'
      fill='#fff'
      {...props}
    />
  </svg>
);
